import React, { Component } from 'react';
export function Phase1Slide() {
  const components = [{
    image: 'https://cdn.magicpatterns.com/uploads/8ZCjjSRb6NNpHhB6fGNWC9/IoT_with_mobilizer.png',
    title: 'IoT Device with Immobilizer',
    desc: 'Installed on every motorcycle to enable tracking, control, and enforcement',
    imgClass: 'object-contain p-4'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/rqzz6jtRtUgC9B2UQ2z42Z/App_main_screen_1.png',
    title: 'Driver Mobile Application',
    desc: 'Ensures verified driver identity and manages all delivery activities',
    imgClass: 'object-contain p-2'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/cF2xqiaukKPQwCwprQdTkn/Pair2_Web_portal_1.png',
    title: 'Centralized Web Portal',
    desc: 'Provides full visibility and control for companies and authorities',
    imgClass: 'object-contain p-2'
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-16 py-10" data-id="element-320">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-321">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-10 w-auto object-contain" data-id="element-322" />
      </div>

      {/* Title */}
      <div className="text-center mt-4 shrink-0" data-id="element-323">
        <span className="text-sm font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-324">
          Phase 1
        </span>
        <h1 className="text-[1.75rem] font-bold text-[#1a1a2e] mt-2" data-id="element-325">
          Standardizing Delivery Operations with Pair2 FMS
        </h1>
      </div>

      {/* Top Statement */}
      <div className="text-center mt-6 mb-8 shrink-0" data-id="element-326">
        <h2 className="text-[1.25rem] font-semibold text-[#1a1a2e]" data-id="element-327">
          Mandatory Adoption of Pair2 FMS
        </h2>
        <p className="text-gray-500 text-[0.9375rem] mt-1" data-id="element-328">
          All delivery operators are onboarded onto a unified fleet management
          system
        </p>
      </div>

      {/* Divider */}
      <div className="w-full h-px bg-gray-100 shrink-0" data-id="element-329"></div>

      {/* 3 Core Components */}
      <div className="flex-grow flex items-center justify-center gap-10 py-6" data-id="element-330">
        {components.map((comp, idx) => <div key={idx} className="flex-1 flex flex-col items-center text-center max-w-sm" data-id="element-331">
            {/* Image Container */}
            <div className="w-full h-64 rounded-2xl bg-[#f8f9fb] border border-gray-100 flex items-center justify-center mb-5 overflow-hidden" data-id="element-332">
              <img src={comp.image} alt={comp.title} className={`w-full h-full ${comp.imgClass}`} data-id="element-333" />
            </div>

            {/* Title */}
            <h3 className="font-bold text-[1.0625rem] text-[#1a1a2e] mb-2 leading-tight" data-id="element-334">
              {comp.title}
            </h3>

            {/* Description */}
            <p className="text-gray-500 text-[0.875rem] leading-relaxed max-w-[90%]" data-id="element-335">
              {comp.desc}
            </p>
          </div>)}
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 pb-2" data-id="element-336">
        <p className="text-[0.9375rem] italic text-gray-500" data-id="element-337">
          "A unified operational layer connecting drivers, vehicles, and control
          systems."
        </p>
      </div>
    </div>;
}